import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { Curriculum } from "@/components/site/Curriculum";
import { Instructor } from "@/components/site/Instructor";
import { Pricing } from "@/components/site/Pricing";
import { BehindTheBraid } from "@/components/site/BehindTheBraid";
import { Testimonials } from "@/components/site/Testimonials";
import { Faq } from "@/components/site/Faq";
import { Waitlist } from "@/components/site/Waitlist";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useSmoothScroll();
  return (
    <div data-testid="landing-page" className="bg-wine-deep">
      <Navbar />
      <Hero />
      <BrandMarquee />
      <Curriculum />
      <Instructor />
      <Pricing />
      <BehindTheBraid />
      <Testimonials />
      <Faq />
      <Waitlist />
      <Footer />
    </div>
  );
}
